/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description EducationalElement Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { educationalMaterial: educationalElementEndpoints } = endpoints;

export class EducationalElementService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get educationalElements list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get educationalElements list.
   */
  getEducationalElements = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = educationalElementEndpoints.element;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get educationalElement info by id
   * @param { string } id - EducationalElement id.
   * @return { Object } - Get educationalElements list.
   */
  getEducationalElementById = async (id) => {
    const url = `${educationalElementEndpoints.element}/${id}`;
    return this.http.get(url);
  };

  /**
   * Get educationalElement info by category id
   * @param { string } id - Category id.
   * @return { Object } - Get educationalElements list.
   */
  getEducationalElementByCategoryId = async (categoryId) => {
    const url = `${educationalElementEndpoints.elementByCategoryId}/${categoryId}`;
    return this.http.get(url);
  };

  /**
   * Create educationalElement
   * @param { object } data - EducationalElement data.
   * @return { promise } - The educationalElement promise object.
   */
  createEducationalElement = async (data) => {
    const body = { ...data };
    const url = educationalElementEndpoints.element;
    return this.http.post(url, body);
  };

  /**
   * Delete educationalElement by id
   * @param { string } id - EducationalElement id.
   * @return { Object } - Get educationalElements list.
   */
  deleteEducationalElementById = async (id) => {
    const url = `${educationalElementEndpoints.element}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update educationalElement
   * @param { string } data - EducationalElement data.
   * @return { promise } - The educationalElement promise object.
   */
  updateEducationalElement = async (data, id) => {
    const body = { ...data };
    const url = `${educationalElementEndpoints.element}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new EducationalElementService(externalConnector);
